import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Screens from '..';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import QueryParamsProxy from '../../utils/queryParamProxy';
import routeParamConstants, { ShopTypes } from '../../utils/routeParamConstants';
import RewardCenterOnboarding from '../../utils/rewardCenterOnboarding';

var VipAccessFlow = /*#__PURE__*/function (_Component) {
  _inherits(VipAccessFlow, _Component);

  var _super = _createSuper(VipAccessFlow);

  function VipAccessFlow() {
    var _this;

    _classCallCheck(this, VipAccessFlow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.purchaseVipAccessHandler = function () {
      var _QueryParamsProxy$set;

      Logger.setActionTrigger('vipAccessPopup');

      _this.props.dismissModal();

      QueryParamsProxy.setQueryParams((_QueryParamsProxy$set = {}, _defineProperty(_QueryParamsProxy$set, routeParamConstants.PARAM_MODAL, Screens.Shop), _defineProperty(_QueryParamsProxy$set, routeParamConstants.PARAM_SHOP_TYPE, ShopTypes.VIP), _QueryParamsProxy$set));
      var trigger = Logger.getActionTrigger();
      var eventPayload = {
        balance_before: _this.props.coin.toString(),
        type: 'vip',
        trigger: trigger || ''
      };
      Logger.sendEvent(EVENT_TYPES.STORE_OPENED, eventPayload);
    };

    _this.redeemVipAccessHandler = function () {
      _this.props.dismissModal();

      RewardCenterOnboarding.showModal(Screens.RewardCenter, true);
    };

    _this.playNowHandler = function () {
      _this.props.dismissModal();

      QueryParamsProxy.navigate(_this.props.navigation, Screens.VIP);
    };

    return _this;
  }

  _createClass(VipAccessFlow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isVipRoomUnlocked = _this$props.isVipRoomUnlocked,
          enterRequirements = _this$props.enterRequirements,
          copys = _this$props.copys;
      return this.props.render({
        purchaseVipAccess: this.purchaseVipAccessHandler,
        redeemVipAccess: this.redeemVipAccessHandler,
        playNow: this.playNowHandler,
        enterRequirements: enterRequirements,
        isVipRoomUnlocked: isVipRoomUnlocked,
        copys: copys
      });
    }
  }]);

  return VipAccessFlow;
}(Component);

export { VipAccessFlow as default };